import { MessageCircle } from "lucide-react";

const WA_NUMBER = "447497498669"; // 07497 498669 in international format
const WA_TEXT = encodeURIComponent(
  "Hi J7 Collective — I’d like a quote for ClearShield glass protection."
);

export default function WhatsAppButton() {
  return (
    <a
      data-testid="whatsapp-float-button"
      href={`https://wa.me/${WA_NUMBER}?text=${WA_TEXT}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 left-6 z-40 group flex items-center gap-3 pl-4 pr-5 py-3.5 rounded-full bg-[#25D366] text-white font-semibold shadow-2xl shadow-emerald-900/30 hover:bg-[#1DA851] transition-all hover:scale-105"
    >
      <span className="relative flex w-9 h-9 items-center justify-center rounded-full bg-white/15">
        <span className="absolute inset-0 rounded-full bg-white/30 animate-ping opacity-60" />
        {/* WhatsApp glyph */}
        <svg
          viewBox="0 0 32 32"
          className="relative w-5 h-5 fill-white"
          aria-hidden="true"
        >
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.515 2.464-1.345.13-.345.13-.66.13-.97 0-.16-.043-.244-.143-.345-.246-.243-1.7-.93-2.107-1.246-.16-.123-.443-.143-.61-.143zm-2.964-9.6c-3.96 0-7.262 3.144-7.262 7.262 0 1.275.376 2.484 1.06 3.55l-1.075 3.246 3.39-.998c.99.515 2.107.792 3.165.792 3.96 0 7.262-3.144 7.262-7.262S20.106 7.605 16.146 7.605zm0 13.18c-1.06 0-2.075-.358-2.95-.86l-.215-.117-2.107.617.617-2.04-.13-.214c-.616-.974-.93-2.09-.93-3.234 0-3.262 2.65-5.913 5.913-5.913 1.58 0 3.062.616 4.183 1.732a5.864 5.864 0 0 1 1.732 4.18c0 3.262-2.65 5.85-5.913 5.85z"/>
          <path d="M27.572 4.49C24.494 1.4 20.39-.336 16.043-.336c-8.962 0-16.25 7.288-16.25 16.25 0 2.866.747 5.66 2.164 8.124L-.336 32.336l8.485-2.222a16.207 16.207 0 0 0 7.894 2.014h.007c8.962 0 16.25-7.288 16.253-16.25 0-4.347-1.69-8.444-4.731-11.388zm-11.53 24.967h-.005a13.487 13.487 0 0 1-6.876-1.884l-.493-.293-5.107 1.339 1.36-4.974-.32-.508a13.477 13.477 0 0 1-2.066-7.226c.004-7.45 6.066-13.512 13.515-13.512 3.61 0 7.005 1.407 9.555 3.96a13.43 13.43 0 0 1 3.952 9.56c-.004 7.45-6.066 13.538-13.515 13.538z"/>
        </svg>
      </span>
      <span className="hidden sm:inline text-sm tracking-wide">
        Chat on WhatsApp
      </span>
    </a>
  );
}
